import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import RESTDataCache from 'dataProvider/api/cacheData';
import { PROPERTIES_JSON } from 'core/constants';
import { getPathFromPlaceAndType } from 'utils/paths';
import { PATH } from '../../envs/core';
import { nearestTown } from '../../constants/api';

export const nearestTownRest = (townId, latitude, longitude, electionType) => {
  const id = `id=${townId}`;
  const lat = `&lat=${latitude}`;
  const lon = `&lon=${longitude}`;

  const filter = `${id}${lat}${lon}&size=10`;

  return Axios.get(`${PATH}${nearestTown}${filter}`).then(async response => {
    const props = await RESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
    const content = response.data.content.map(item => ({
      ...item,
      path: getPathFromPlaceAndType(item, electionType, props)
    }));

    const sitesWithPath = {
      ...response.data,
      content
    };
    return sitesWithPath;
  });
};

export const useNearestTown = ({
  townId,
  latitude,
  longitude,
  electionType
}) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    nearestTownRest(townId, latitude, longitude, electionType).then(
      response => {
        setData(response.content);
      }
    );
  }, [townId, latitude, longitude]);
  return { data };
};

export const NearestTownProvider = ({
  townId,
  longitude,
  latitude,
  children
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    nearestTownRest.then(response => {
      setData(response.data.content);
    });
  }, [townId, latitude, longitude]);

  return children(data);
};

NearestTownProvider.propTypes = {
  townId: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};

NearestTownProvider.defaultProps = {
  latitude: 0,
  longitude: 0
};
